/* import __COLOCATED_TEMPLATE__ from './revisions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();